import { render, staticRenderFns } from "./BindAccountDialog.vue?vue&type=template&id=43b18826&scoped=true"
import script from "./BindAccountDialog.vue?vue&type=script&lang=js"
export * from "./BindAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./BindAccountDialog.vue?vue&type=style&index=0&id=43b18826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b18826",
  null
  
)

export default component.exports